import { PAGES, DYNAMIC_ROUTES } from 'common/app-constants'
import { element } from 'prop-types'
import { lazy } from 'react'

// Lazy Import
const LandingPage = lazy(() => import('pages/LandingPage'))
const MasterDataPage = lazy(() => import('pages/MasterDataPage'))
const DemandStrategy = lazy(() => import('pages/DemandStrategy'))
const NotFoundPage = lazy(() => import('pages/NotFoundPage'))
const AllocationPage = lazy(() => import('pages/Actuals/tabs/AllocationPage'))
const Actuals = lazy(() => import('pages/Actuals'))
const ImportExport = lazy(() => import('pages/ImportExport'))
const Glossary = lazy(() => import('pages/Glossary'))
const Login = lazy(() => import('pages/Login'))
const Redirection = lazy(() => import('pages/Redirection'))
const CreateContractPage = lazy(() => import('pages/Actuals/tabs/Contract/CreateContractPage/CreateContractPage'))
const AppRoutes = [
  {
    id: 0,
    path: PAGES.DASHBOARD,
    element: LandingPage,
  },
  {
    id: 1,
    path: PAGES.DEMAND_UPDATES,
    element: DemandStrategy,
  },
  {
    id: 2,
    path: PAGES.ACTUALS,
    element: Actuals,
  },
  {
    id: 3,
    path: PAGES.MASTER_DATA,
    element: MasterDataPage,
  },
  {
    id: 4,
    path: PAGES.IMPORT_EXPORT,
    element: ImportExport,
  },
  {
    id: 5,
    path: PAGES.GLOSSARY,
    element: Glossary,
  },
  {
    id: 6,
    path: PAGES.NOT_FOUND,
    element: NotFoundPage,
  },
  {
    id: 7,
    path: PAGES.ALLOCATIONTEST,
    element: AllocationPage,
  },
  {
    id: 10,
    path: PAGES.CREATE_CONTRACT,
    element: CreateContractPage,
  },
  {
    id: 8,
    path: PAGES.LOGIN,
    element: Login,
  },
  {
    id: 9,
    path: DYNAMIC_ROUTES.IMPORT_EXPORT_DETAILS,
    element: Redirection,
  },
]

export default AppRoutes
